document.addEventListener('DOMContentLoaded', () => {
    // Remove 'location' query parameter from URL after page loads (clean URL)
    if (window.location.search.includes('location=')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('location');
        window.history.replaceState({}, '', url.toString());
    }

    // Global flag to track if location changing is allowed (initialized from AJAX)
    window.allowLocationChange = true;

    // Load location switcher button value via AJAX (not whole header)
    // This will also set allowLocationChange flag
    loadLocationSwitcherValue();

    // Cookie utilities
    const CookieUtils = {
        getCookieDomain: function() {
            const hostname = window.location.hostname;
            // For production domains (garrett.com), use leading dot for subdomain support
            if (hostname.includes('garrett.com')) {
                return '.garrett.com';
            }
            // For local/development (localhost, .test, .local, .dev), don't use domain
            // This allows cookies to work on localhost
            if (hostname.match(/\.(test|local|localhost|dev)$/) || hostname === 'localhost' || hostname === '127.0.0.1') {
                return '';
            }
            // For other domains, use leading dot if it has subdomains
            if (hostname.split('.').length > 2) {
                return '.' + hostname.split('.').slice(-2).join('.');
            }
            return '';
        },
        set: function(name, value, days = 365) {
            const expires = new Date(Date.now() + days * 864e5).toUTCString();
            const domain = this.getCookieDomain();

            // Clean up old cookies with wrong domains before setting new one
            // This prevents duplicate cookies when switching between garrett.com and www.garrett.com
            const oldDomains = ['garrett.com', 'www.garrett.com', '.garrett.com'];
            oldDomains.forEach(oldDomain => {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${oldDomain}; SameSite=Lax`;
            });
            // Also clean up cookie without domain (current host only)
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;

            // Set the cookie with correct domain (empty string for localhost)
            const domainPart = domain ? `; domain=${domain}` : '';
            document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/${domainPart}; SameSite=Lax`;
        },

        get: function(name) {
            return document.cookie.split('; ').reduce((r, v) => {
                const parts = v.split('=');
                return parts[0] === name ? decodeURIComponent(parts[1]) : r;
            }, '');
        },

        exists: function(name) {
            return document.cookie.split(';').some((item) => item.trim().startsWith(`${name}=`));
        }
    };

    // Country utilities
    const CountryUtils = {
        isUSA: function(countryCode) {
            return countryCode.toUpperCase() === 'US';
        },

        getOriginType: function(countryCode) {
            return this.isUSA(countryCode) ? 'domestic' : 'international';
        }
    };

    // DOM elements
    let locationPopup = null; // Will be loaded dynamically via AJAX
    let locationForm = null;
    let locationSelect = null;
    let locationClose = null;
    let locationSwitchers = document.querySelectorAll('#location-switcher, .location-switcher .wp-block-button__link');
    let locationLink = document.getElementById('location-link');
    const locationPopupContainer = document.getElementById('location-popup-container');

    // Cache for popup HTML (loaded once per session)
    let popupHtmlLoaded = false;

    // Check location change permission periodically (after AJAX loads)
    function checkLocationChangePermission() {
        const allowChange = window.allowLocationChange !== false;

        if (!allowChange) {
            if (locationPopup) {
                locationPopup.style.display = 'none';
            }
            // Protect cookies - restore them if manually changed
            protectCookies();
        }

        return allowChange;
    }

    // Location form handler will be attached dynamically when popup is loaded
    // See attachLocationFormHandler() function

    // Handle location switcher clicks using event delegation (works with caching)
    // Use a guard to prevent duplicate handlers if script runs multiple times
    if (!window.locationSwitcherHandlerAttached) {
        document.addEventListener('click', function(e) {
            const target = e.target;
            if (!target) return;

            // Check if click is on location switcher or location link
            const locationSwitcher = target.closest('#location-switcher');
            const locationLink = target.closest('#location-link');

            if (locationSwitcher || locationLink) {
                e.preventDefault();
                e.stopPropagation();

                // Check if location changing is allowed
                if (!checkLocationChangePermission()) {
                    return;
                }

                showLocationPopup();
            }
        });

        window.locationSwitcherHandlerAttached = true;
    }

    // Helper functions
    function showLocationPopup() {
        // Check permission first
        if (!checkLocationChangePermission()) {
            return;
        }

        // If popup HTML hasn't been loaded yet, load it via AJAX
        if (!popupHtmlLoaded) {
            loadLocationPopupHtml().then(() => {
                // After loading, show the popup
                if (locationPopup) {
                    locationPopup.classList.add('active');
                    locationPopup.style.display = '';
                }
            }).catch((error) => {
                console.error('Error loading location popup:', error);
            });
            return;
        }

        // Popup already loaded, just show it
        if (locationPopup) {
            locationPopup.classList.add('active');
            locationPopup.style.display = '';
        }
    }

    // Load location popup HTML dynamically via AJAX
    function loadLocationPopupHtml() {
        return new Promise((resolve, reject) => {
            // Check if container exists
            if (!locationPopupContainer) {
                reject(new Error('Location popup container not found'));
                return;
            }

            // Check if garrett object exists (from wp_localize_script)
            if (typeof garrett === 'undefined' || !garrett.resturl) {
                reject(new Error('Garrett REST URL not available'));
                return;
            }

            const popupHeaders = { 'Accept': 'application/json' };

            // Needed for WordPress to see a logged-in visitor; the endpoint re-checks permission
            // server-side and answers 403 when the visitor may not change location.
            if (garrett.rest_nonce) {
                popupHeaders['X-WP-Nonce'] = garrett.rest_nonce;
            }

            fetch(garrett.resturl + 'location/popup', {
                method: 'GET',
                credentials: 'same-origin',
                headers: popupHeaders,
            })
            .then(response => response.json())
            .then(data => {
                if (data && data.html) {
                    // Insert popup HTML into container
                    locationPopupContainer.innerHTML = data.html;

                    // Re-query DOM elements after inserting HTML
                    locationPopup = document.querySelector('.site-header__location');
                    locationForm = document.querySelector('.site-header__location--form');
                    locationSelect = document.querySelector('select[name="user-location"]');
                    locationClose = document.querySelector('.site-header__location--close');

                    // Attach form handler if form exists
                    if (locationForm) {
                        attachLocationFormHandler();
                    }

                    // Attach close button handler
                    if (locationClose) {
                        locationClose.addEventListener('click', () => {
                            hideLocationPopup();
                        });
                    }

                    popupHtmlLoaded = true;
                    resolve();
                } else {
                    reject(new Error(data.data?.message || 'Failed to load location popup'));
                }
            })
            .catch(error => {
                reject(error);
            });
        });
    }

    // Attach location form submission handler
    function attachLocationFormHandler() {
        if (!locationForm) {
            return;
        }


        // Remove any existing listeners to prevent duplicates
        const newForm = locationForm.cloneNode(true);
        locationForm.parentNode.replaceChild(newForm, locationForm);
        locationForm = newForm;
        locationSelect = locationForm.querySelector('select[name="user-location"]');


        locationForm.addEventListener('submit', function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!locationSelect) {
                return;
            }

            if (!checkLocationChangePermission()) {
                return;
            }

            const selectedValue = locationSelect.value;

            let countryCode = 'US';
            let countryName = 'United States';
            let originType = 'domestic';

            if (selectedValue === 'international') {
                countryCode = 'XX';
                countryName = 'International';
                originType = 'international';
            } else if (selectedValue) {
                countryCode = selectedValue;
                const selectedOption = locationSelect.options[locationSelect.selectedIndex];
                countryName = selectedOption ? selectedOption.text : countryCode;
                originType = CountryUtils.getOriginType(countryCode);
            }

            // ALWAYS set cookies - update them with the new selection
            CookieUtils.set('country', countryCode);
            CookieUtils.set('origin', originType);

            // Reload page if:
            // 1. First time setting cookies
            // 2. Switching between domestic and international markets
            // 3. Always reload to ensure server sees the cookie change
            setTimeout(() => {
                const url = new URL(window.location.href);
                url.searchParams.set('location', Date.now());
                window.location.href = url.toString();
            }, 150);
        });

    }

    function hideLocationPopup() {
        if (locationPopup) {
            locationPopup.classList.remove('active');
        }
    }

    function updateLocationDisplays(countryName) {
        // Update all location switcher text
        locationSwitchers.forEach(locationSwitcher => {
            locationSwitcher.textContent = countryName;
        });

        // Update location link text
        if (locationLink) {
            locationLink.textContent = countryName;
        }
    }

    function protectCookies() {
        // This function protects cookies on the client side
        // The server-side GeoLocation::protectCookies() already handles server-side protection
        // This adds an extra layer of client-side protection

        // Store initial cookie values
        const initialCountry = CookieUtils.get('country');
        const initialOrigin = CookieUtils.get('origin');

        // Check periodically if cookies have been manually changed
        // Server will restore them on next request, but we can detect and reload immediately
        if (typeof protectCookies.intervalId === 'undefined') {
            protectCookies.intervalId = setInterval(() => {
                if (!checkLocationChangePermission()) {
                    const currentCountry = CookieUtils.get('country');
                    const currentOrigin = CookieUtils.get('origin');

                    // If cookies were manually changed, reload to let server restore them
                    if (currentCountry !== initialCountry || currentOrigin !== initialOrigin) {
                        window.location.reload();
                    }
                }
            }, 2000); // Check every 2 seconds
        }
    }

    // Level 3 Navigation Click Handlers
    const level3Toggles = document.querySelectorAll('[data-level3-toggle]');
    const level3Closes = document.querySelectorAll('[data-level3-close]');

    // Handle level 3 toggle clicks
    level3Toggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();

            const level2Item = this.closest('.level-2__li');

            if (!level2Item) {
                return;
            }

            const isOpen = level2Item.classList.contains('level3-open');

            // Close all other level 3 menus and remove forced visibility
            document.querySelectorAll('.level-2__li.level3-open').forEach(item => {
                item.classList.remove('level3-open');
                // Remove forced visibility from parent level-1 item
                const parentLevel1 = item.closest('.site-header__nav--main > li');
                if (parentLevel1) {
                    parentLevel1.classList.remove('level3-active');
                }
            });

            // Toggle current level 3 menu
            if (!isOpen) {
                level2Item.classList.add('level3-open');
                // Force visibility of parent level-1 item
                const parentLevel1 = level2Item.closest('.site-header__nav--main > li');
                if (parentLevel1) {
                    parentLevel1.classList.add('level3-active');
                }
            }
        });
    });

    // Handle level 3 close clicks
    level3Closes.forEach(close => {
        close.addEventListener('click', function(e) {
            e.preventDefault();

            const level2Item = this.closest('.level-2__li');
            level2Item.classList.remove('level3-open');

            // Remove forced visibility from parent level-1 item
            const parentLevel1 = level2Item.closest('.site-header__nav--main > li');
            if (parentLevel1) {
                parentLevel1.classList.remove('level3-active');
            }
        });
    });

    // Close level 3 when hovering over OTHER level 1 items (not the parent)
    const level1Items = document.querySelectorAll('.site-header__nav--main > li');
    level1Items.forEach(level1Item => {
        level1Item.addEventListener('mouseenter', function() {
            // Close level 3 items that are NOT inside this level-1 item
            document.querySelectorAll('.level-2__li.level3-open').forEach(openItem => {
                // Check if this open level-3 is inside the current level-1 item
                const isInCurrentDropdown = this.contains(openItem);

                // Only close if it's NOT in the current level-1 dropdown
                if (!isInCurrentDropdown) {
                    openItem.classList.remove('level3-open');

                    // Remove forced visibility from parent level-1 item
                    const parentLevel1 = openItem.closest('.site-header__nav--main > li');
                    if (parentLevel1) {
                        parentLevel1.classList.remove('level3-active');
                    }
                }
            });
        });
    });

    // Close level 3 when clicking outside (desktop only)
    // Use a guard to prevent duplicate handlers if script runs multiple times
    if (!window.level3ClickOutsideHandlerAttached) {
        document.addEventListener('click', function(e) {
            // Check if we're on desktop
            if (window.innerWidth < 1024) return;

            // Don't close if clicking on location popup or location switcher
            const isClickOnLocationPopup = e.target.closest('.site-header__location');
            const isClickOnLocationSwitcher = e.target.closest('#location-switcher, #location-link');
            if (isClickOnLocationPopup || isClickOnLocationSwitcher) {
                return;
            }

            // Check if click is outside level-3 and not on a level3-toggle
            const isClickInsideLevel3 = e.target.closest('.level-3');
            const isClickOnToggle = e.target.closest('[data-level3-toggle]');

            if (!isClickInsideLevel3 && !isClickOnToggle) {
                // Close all open level 3 menus
                document.querySelectorAll('.level-2__li.level3-open').forEach(item => {
                    item.classList.remove('level3-open');

                    // Remove forced visibility from parent level-1 item
                    const parentLevel1 = item.closest('.site-header__nav--main > li');
                    if (parentLevel1) {
                        parentLevel1.classList.remove('level3-active');
                    }
                });
            }
        });

        window.level3ClickOutsideHandlerAttached = true;
    }
});

/**
 * Set the location switcher button value
 *
 * Resolves from the `country` cookie first, which needs no request at all. The AJAX call is now only
 * a fallback for the one case the cookie cannot cover: a first-time visitor with no cookie landing on
 * a cached page, where PHP never ran to set one.
 *
 * This used to fire on every single page view, including every JS-executing bot page view, which put
 * an uncacheable admin-ajax.php request in front of every page load. Under load those requests queued
 * behind the PHP-FPM pool and were observed waiting up to 30 seconds.
 *
 * @see \TotalDigital\Theme\LocationLabel
 */
function loadLocationSwitcherValue() {
    // Get location switcher buttons
    const locationSwitchers = document.querySelectorAll('#location-switcher, .location-switcher .wp-block-button__link');
    const locationLink = document.getElementById('location-link');

    if (locationSwitchers.length === 0 && !locationLink) {
        return; // No location switcher buttons found
    }

    // Fast path: the inline payload in wp_head already carries the permission flag and the country
    // map, so the label resolves locally. apply() returns false only when the country is not known
    // yet, which is the sole case that still needs the server.
    // NOTE: checkLocationChangePermission() lives inside the DOMContentLoaded closure and is not in
    // scope here. It is not needed either - the click handler calls it itself before opening the
    // popup, which matches the behaviour of the AJAX path this replaces.
    if (window.garrettCountryLabel) {
        window.allowLocationChange = window.garrettCountryLabel.allowChange !== false;

        if (window.garrettCountryLabel.apply()) {
            return;
        }
    }

    // Slow path, reached only when the country is still unknown: no cookie and no country from the
    // Sucuri edge. Asked once, after paint, and the response sets the cookie so it is not asked again.
    if (typeof garrett === 'undefined' || !garrett.resturl) {
        console.warn('Garrett REST URL not available, skipping location switcher update');
        return;
    }

    const restHeaders = { 'Accept': 'application/json' };

    // Sent so WordPress recognises a logged-in visitor; without it an Intl Testers member would be
    // answered as anonymous. A stale nonce from cached HTML degrades to the anonymous answer.
    if (garrett.rest_nonce) {
        restHeaders['X-WP-Nonce'] = garrett.rest_nonce;
    }

    fetch(garrett.resturl + 'location', {
        method: 'GET',
        credentials: 'same-origin',
        headers: restHeaders
    })
    .then(response => response.json())
    .then(data => {
        if (data && data.countryName) {
            const countryName = data.countryName || 'United States';
            const allowChange = data.allowLocationChange !== false; // Default to true if not set

            // Update global flag
            window.allowLocationChange = allowChange;

            // Update location switcher buttons
            const updatedLocationSwitchers = document.querySelectorAll('#location-switcher, .location-switcher .wp-block-button__link');
            updatedLocationSwitchers.forEach(switcher => {
                switcher.textContent = countryName;
                if (!allowChange) {
                    switcher.style.cursor = 'default';
                    // Don't set pointer-events: none - let click handler prevent action instead
                } else {
                    switcher.style.cursor = '';
                }
            });

            // Update location link
            const updatedLocationLink = document.getElementById('location-link');
            if (updatedLocationLink) {
                updatedLocationLink.textContent = countryName;
                if (!allowChange) {
                    updatedLocationLink.style.cursor = 'default';
                    // Don't set pointer-events: none - let click handler prevent action instead
                } else {
                    updatedLocationLink.style.cursor = '';
                }
            }

            // Hide location popup if location changing is not allowed
            const locationPopup = document.querySelector('.site-header__location');
            if (!allowChange && locationPopup) {
                locationPopup.style.display = 'none';
            } else if (allowChange && locationPopup) {
                locationPopup.style.display = '';
            }

            // Hide location popup if disabled
            if (!allowChange) {
                setTimeout(() => {
                    const checkLocationPopup = document.querySelector('.site-header__location');
                    if (checkLocationPopup) {
                        checkLocationPopup.style.display = 'none';
                    }
                }, 100);
            }
        }
    })
    .catch(error => {
        console.warn('Failed to load location switcher value from the REST API:', error);
    });
}
